module.exports = __webpack_public_path__ + "img/class-cnt-bn.944587e5.png";